import * as s from '~js/utils/selectors';
import * as c from '~js/utils/classes';
import { Modals } from '~js/components/modals';

export class StoreAvailability {
  constructor(container) {
    this.container = container;
  }

  updateContent(variantId, productTitle) {
    this._fetchStoreAvailabilities(variantId, productTitle);
  }

  clearContent() {
    this.container.innerHTML = '';
  }

  _initModal() {
    return new Modals('StoreAvailabilityModal', {
      close: s.selectors$Q.storeAvailabilityModalClose,
      open: s.selectors$Q.storeAvailabilityModalOpen,
      closeModalOnClick: true,
      openClass: c.classes$H.openClass,
      scrollIntoView: false,
    });
  }

  _fetchStoreAvailabilities(variantId, productTitle) {
    const variantSectionUrl = '/variants/' + variantId + '/?section_id=store-availability';
    this.clearContent();

    const self = this;
    fetch(variantSectionUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (storeAvailabilityHTML) {
        const body = document.querySelector(s.selectors$Q.body);
        let storeAvailabilityModal = body.querySelector(s.selectors$Q.storeAvailabilityModal);
        if (storeAvailabilityModal) {
          storeAvailabilityModal.remove();
        }

        self.container.innerHTML = storeAvailabilityHTML;
        self.container.innerHTML = self.container.firstElementChild.innerHTML;

        if (self.container.firstElementChild.innerHTML.trim() === '') {
          self.clearContent();
          return;
        }

        const storeAvailabilityModalOpen = self.container.querySelector(s.selectors$Q.storeAvailabilityModalOpen);
        // Only create modal if open modal element exists
        if (!storeAvailabilityModalOpen) {
          return;
        }

        self.modal = self._initModal();
        self._updateProductTitle(productTitle);

        storeAvailabilityModal = self.container.querySelector(s.selectors$Q.storeAvailabilityModal);
        if (storeAvailabilityModal) {
          body.appendChild(storeAvailabilityModal);
        }
      });
  }

  _updateProductTitle(productTitle) {
    const storeAvailabilityModalProductTitle = this.container.querySelector(
      s.selectors$Q.storeAvailabilityModalProductTitle
    );
    storeAvailabilityModalProductTitle.textContent = productTitle;
  }
}